import { useTranslation } from '@exam-room/translations';

import {
  Button,
  ArrowBackRoundedIcon,
  ArrowForwardRoundedIcon,
  BookmarkBorderOutlinedIcon,
  DesignServicesOutlinedIcon,
  FactCheckOutlinedIcon,
} from '../../../../components';

export default function ExamGuidelines() {
  const { t } = useTranslation();

  return (
    <div className='flex w-full flex-col gap-4 text-left'>
      <div className='flex flex-col gap-2'>
        <h4 className='border-primary border-l-4 pl-4 text-lg font-semibold'>
          {t('instruction.examGuideline.title')}
        </h4>
        <p className='text-text-secondary pl-5 text-sm'>
          {t('instruction.examGuideline.description')}
        </p>
      </div>
      <ol className='list-decimal space-y-1.5 pl-5 text-sm leading-6'>
        <li data-exam-content>
          {t('instruction.examGuideline.content.1.title')}
          <ul className='list-disc space-y-1.5 pt-1.5 pl-1.5'>
            <li>
              <div className='white-space-nowrap flex items-center gap-1'>
                {t('instruction.examGuideline.content.1.clickAt')}{' '}
                <div className='ignore-font-scale inline-flex aspect-square h-5 grow-0 rounded-full border-2 border-gray-400 text-center' />{' '}
                {t('instruction.examGuideline.content.1.result.1')}
              </div>
            </li>
            <li>
              <div className='flex items-center gap-1'>
                {t('instruction.examGuideline.content.1.clickAtButton')}
                <Button
                  size='sm'
                  variant='outlined'
                  className='pointer-events-none flex items-center gap-1 px-2 py-[4.5px] text-xs'
                >
                  {t('instruction.examGuideline.content.1.button.2')}
                  <ArrowForwardRoundedIcon className='text-base' />
                </Button>
                {t('instruction.examGuideline.content.1.result.2')}
              </div>
            </li>
            <li>
              <div className='flex items-center gap-1'>
                {t('instruction.examGuideline.content.1.clickAtButton')}
                <Button
                  size='sm'
                  variant='outlined'
                  className='pointer-events-none flex items-center gap-1 px-2 py-[4.5px] text-xs'
                >
                  <ArrowBackRoundedIcon className='text-base' />
                  {t('instruction.examGuideline.content.1.button.3')}
                </Button>
                {t('instruction.examGuideline.content.1.result.3')}
              </div>
            </li>
            <li>
              <div className='flex items-center gap-1'>
                {t('instruction.examGuideline.content.1.clickAtButton')}
                <Button
                  size='sm'
                  variant='outlined'
                  className='pointer-events-none flex items-center gap-1 px-2 py-[4.5px] text-xs'
                >
                  <BookmarkBorderOutlinedIcon className='text-base' />
                  {t('instruction.examGuideline.content.1.button.4')}
                </Button>
                {t('instruction.examGuideline.content.1.result.4')}
              </div>
            </li>
            <li>
              <div className='flex items-center gap-1'>
                {t('instruction.examGuideline.content.1.clickAtButton')}
                <Button
                  size='sm'
                  variant='outlined'
                  className='pointer-events-none flex items-center gap-1 px-2 py-[4.5px] text-xs'
                >
                  <DesignServicesOutlinedIcon className='text-base' />
                  {t('instruction.examGuideline.content.1.button.5')}
                </Button>
                {t('instruction.examGuideline.content.1.result.5')}
              </div>
            </li>
            <li>
              <div className='flex items-center gap-1'>
                {t('instruction.examGuideline.content.1.clickAtButton')}
                <Button
                  size='sm'
                  variant='default'
                  className='pointer-events-none flex items-center gap-1 px-2 py-[4.5px] text-xs'
                >
                  <FactCheckOutlinedIcon className='text-base' />
                  {t('instruction.examGuideline.content.1.button.6')}
                </Button>
                {t('instruction.examGuideline.content.1.result.6')}
              </div>
            </li>
          </ul>
        </li>
        <li data-exam-content>
          {t('instruction.examGuideline.content.2.title')}{' '}
          <Button size='sm' variant='default' className='pointer-events-none px-2'>
            {t('instruction.examGuideline.content.2.button')}
          </Button>{' '}
          {t('instruction.examGuideline.content.2.result')}
        </li>
        <li data-exam-content>{t('instruction.examGuideline.content.3')}</li>
        <li data-exam-content>{t('instruction.examGuideline.content.4')}</li>
        <li data-exam-content>{t('instruction.examGuideline.content.5')}</li>
      </ol>
    </div>
  );
}
